/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityarchetypedescriptionrebel3Inputs */



/**
* | output |
* | --- |
* | "You can’t stand fake rules or fake people. You love breaking outdated norms, speaking straight, and challenging the ordinary — with you it’s easy to step out..." |
*
* @param {Personalityarchetypedescriptionrebel3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityarchetypedescriptionrebel3 = /** @type {((inputs?: Personalityarchetypedescriptionrebel3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityarchetypedescriptionrebel3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("You can’t stand fake rules or fake people. You love breaking outdated norms, speaking straight, and challenging the ordinary — with you it’s easy to step outside the usual frame.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No soportas las reglas ni las personas falsas. Te encanta romper normas obsoletas, hablar de frente y desafiar lo ordinario: contigo es fácil salir de lo común.")
	return /** @type {LocalizedString} */ ("Ты не терпишь рамок и фальши. Тебе нравится ломать устаревшие правила, говорить прямо и бросать вызов обыденности — с тобой легко выйти за грани привычного.")
});
export { personalityarchetypedescriptionrebel3 as "personalityArchetypeDescriptionRebel" }